import {
  AccordionSummary,
  Box,
  Button,
  Chip,
  IconButton,
  Popover,
  Slider,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";

const Radius = ({ type, onRadiusChange }) => {
  const [radius, setRadius] = useState(20);
  const [anchorEl, setAnchorEl] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const radiusParam = searchParams.get("radius");
    if (radiusParam) {
      setRadius(+radiusParam);
    }
  }, [searchParams]);

  useEffect(() => {
    if (type === "Accordion") {
      onRadiusChange(radius);
    }
  }, [radius]);

  const open = Boolean(anchorEl);
  const id = open ? "user-radius" : undefined;

  useEffect(() => {
    if (open) {
      document.documentElement.style.overflow = "hidden";
      document.documentElement.style.paddingRight = "17px";
    } else {
      document.documentElement.style.overflow = "";
      document.documentElement.style.paddingRight = "";
    }
  }, [open]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRadiusChange = (event) => {
    setRadius(event.target.value);
  };

  const handleRadiusClear = () => {
    // setSelectedDays([]);
  };

  const handleApplyClick = () => {
    setSearchParams({
      ...Object.fromEntries(searchParams),
      radius: radius,
    });

    handleClose();
  };

  const slider = (
    <Slider
      min={1}
      value={radius}
      aria-label="Default"
      valueLabelDisplay="on"
      onChange={handleRadiusChange}
      valueLabelFormat={(value) => {
        return value + " mi";
      }}
    />
  );

  if (type === "Accordion") {
    return (
      <Accordion sx={{ backgroundColor: "#f7f7f7" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="radius-content"
          id="radius-header"
        >
          <Typography>Distance</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ textAlign: "center" }}>{slider}</Box>
        </AccordionDetails>
      </Accordion>
    );
  }

  return (
    <>
      <Chip
        label="Distance"
        variant="outlined"
        color="white"
        onClick={handleClick}
        sx={{ width: "100%", fontSize: { xs: "0.69rem", sm: "0.8125rem" } }}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{ marginTop: "-32px", borderRadius: "25px" }}
        slotProps={{ paper: { sx: { borderRadius: "16px" } } }}
      >
        <Box sx={{ borderRadius: "25px", padding: "0", width: "195px" }}>
          <Stack spacing={2}>
            <Chip
              label="Distance"
              variant="outlined"
              color="white"
              // onClick={handleClick}
              sx={{
                width: "100%",
                fontSize: { xs: "0.69rem", sm: "0.8125rem" },
                backgroundColor: "#0B3C65",
              }}
            />
            {/*<Box*/}
            {/*  sx={{*/}
            {/*    display: "flex",*/}
            {/*    justifyContent: "space-between",*/}
            {/*    alignItems: "center",*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <Typography variant="button" display="block">*/}
            {/*    Distance*/}
            {/*  </Typography>*/}

            {/*  <IconButton aria-label="clear" onClick={handleClose}>*/}
            {/*    <CloseIcon />*/}
            {/*  </IconButton>*/}
            {/*</Box>*/}
            <Box sx={{ padding: "0 18px 18px 18px" }}>
              <Box>{slider}</Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button size="small" variant="text" onClick={handleRadiusClear}>
                  clear
                </Button>
                <Button
                  color="yellow"
                  variant="contained"
                  sx={{
                    borderRadius: "25px",
                    marginTop: "2px",
                    fontWeight: 600,
                  }}
                  onClick={handleApplyClick}
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Stack>
        </Box>
      </Popover>
    </>
  );
};

export default Radius;
